import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=66d3410c&scoped=true&"
import script from "./detail.js?vue&type=script&lang=js&"
export * from "./detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=66d3410c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3410c",
  null
  
)

export default component.exports